<template>
  <div class="header">
    <div v-if="canBackPage" @click="handleClick">
      <Icon name="arrow-left" />
    </div>
    <span>
      {{ headerText }}
    </span>
  </div>
</template>

<script>
import Icon from '@/components/ui/AppIcon.vue';

export default {
  name: 'camera-header',
  components: { Icon },
  props: {
    canBackPage: {
      type: Boolean,
      required: true,
      default: true,
    },
    headerText: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>

<style lang="scss" scoped>
  .header {
    background: var(--gray-600);
    color: #fff;

    height: 52px;
    padding: 16px 24px;

    display: flex;
    justify-content: center;
    align-items: center;

    span {
      @extend .lead;
      text-align: center;
      flex: 1;
      line-height: 26px;
      margin-right: 24px;
    }
  }
</style>
